<template>
  <Navbar :center-text="$t('CollaborationView.collaboration')"
          :message="this.message"
          :message-type="this.messageType">
  </Navbar>
  <div class="container mt-4">
    <div class="row mb-4 justify-content-center align-items-center">
      <div class="col-6 d-flex flex-wrap cards-container justify-content-center align-items-center">
        <div class="card card-yellow text-center shadow-sm">
          <div class="card-body">
            <h5 class="card-title">
              <i class="bi bi-whatsapp"></i>
              {{ $t('CollaborationView.joinWhatsAppGroup') }}
            </h5>
            <p class="card-text">
              <img src="@/assets/qr_code_whatsapp.jpg"
                   alt="QR code to the WhatsApp Group"
                   class="qr-code" />
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
  <Footerbar></Footerbar>
</template>

<script>
import Navbar from "@/components/Navbar.vue";
import Footerbar from "@/components/Footerbar.vue";

export default {
  components: {Footerbar, Navbar},
  data(){
    return {
      message: null,
      messageType: null,
    }
  }
}

</script>

<style scoped>
.qr-code {
  height: 150px;
  width: 150px;
}

.card {
  border: none;
  border-radius: 8px;
  width: 300px !important;
  height: 250px !important;
}

.card-yellow {
  background-color: #EBB02E !important;
  color: #63432A !important;
}

.card-beige {
  background-color: #E7DBC0 !important;
  color: #63432A !important;
}
</style>